/******/ (() => { // webpackBootstrap
  var __webpack_exports__ = {};
  Shopify.theme.jsFeaturedCollection = {
    init: function ($section) {

      // Add settings from schema to current object
      Shopify.theme.jsFeaturedCollection = $.extend(this, Shopify.theme.getSectionData($section));

      this.$section = $section
      this.$sliderEl = $section.find('[data-slider]');
      this.$slides = this.$sliderEl.find('[data-load-more--grid-item]')

      if (this.collection_style == 'slider') {
        this.createSlider();
        $(document).on('Resize:Custom', this.adjustPeak.bind(this));
        this.adjustPeak()
      }
    },
    createSlider: function () {

      const slideData = {
        products_per_slide: this.products_per,
        products_available: this.products_available,
        products_limit: this.products_limit,
      }

      this.slider = this.$sliderEl.flickity({
        freeScroll: false,
        draggable: true,
        cellAlign: 'left',
        wrapAround: true,
        pageDots: true,
        contain: true,
        prevNextButtons: false,
      });
      this.slider.on('settle.flickity', function () {
        this.slider.flickity('resize');
      }.bind(this));

    },
    adjustPeak: function () {
      this.$slides.each((index, slide) => {
        $(slide)[0].style.removeProperty('width')
      })
      let width = this.$slides.eq(0).width()
      this.$slides.css('width', width - width / 16 + 'px')
      this.slider.flickity('resize')
    },
    unload: function ($section) {
      let $slider = $section.find('.flickity-enabled');
      $slider.flickity('destroy');
    }
  }

  /******/
})()
  ;